/* eslint-disable max-len */
// THIS FILE IS USED TO GENERATE CHUNKS PER PAGE
// SO THAT SPA'S CAN LOAD THE NECESSARY CHUNKS PER PAGE
/* eslint-disable no-nested-ternary */
import { generateAsyncRoute } from '@thd-olt-component-react/router';

const ssr = typeof window === 'undefined';

export const getServerPages = async () => {
  const Components = {};
  if (ssr) {
    Components.LandingPage = (await import('./pages/LandingPage')).LandingPage;
    Components.LayoutPreview = (await import('./pages/LayoutPreview')).LayoutPreview;
  }
  return Components;
};

export const getRoutes = (_currentRouteName, currentRouteComponent, serverPages) => ({
  landingA: {
    name: 'LandingPage',
    componentName: 'LandingPage',
    chunk: () => import('./pages/LandingPage'),
    get component() {
      return ssr
        ? serverPages.LandingPage
        : (_currentRouteName === 'LandingPage' && currentRouteComponent)
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk()
            .then((pageModule) => ({ default: pageModule.LandingPage })));
    },
    path: '/:context?/:contentPV?/a/:slug/:guid?',
    channel: null,
    varnish: true
  },
  landingB: {
    name: 'LandingPage',
    componentName: 'LandingPage',
    chunk: () => import('./pages/LandingPage'),
    get component() {
      return ssr
        ? serverPages.LandingPage
        : (_currentRouteName === 'LandingPage' && currentRouteComponent)
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk()
            .then((pageModule) => ({ default: pageModule.LandingPage })));
    },
    path: '/:context?/:contentPV?/b/:slug1?/:slug2?/:guid',
    channel: null,
    varnish: true
  },
  landingC: {
    name: 'LandingPage',
    componentName: 'LandingPage',
    chunk: () => import('./pages/LandingPage'),
    get component() {
      return ssr
        ? serverPages.LandingPage
        : (_currentRouteName === 'LandingPage' && currentRouteComponent)
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk()
            .then((pageModule) => ({ default: pageModule.LandingPage })));
    },
    path: '/:context?/:contentPV?/c/:slug/:guid?',
    channel: null,
    varnish: true
  },
  landingTest: {
    name: 'LayoutPreview',
    componentName: 'LayoutPreview',
    get component() {
      return ssr
        ? serverPages.LayoutPreview
        : (_currentRouteName === 'LayoutPreview' && currentRouteComponent)
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk()
            .then((pageModule) => ({ default: pageModule.LayoutPreview })));
    },
    chunk: () => import('./pages/LayoutPreview'),
    path: '/:context?/:contentPV?/landingPagePV/:LayoutTypeID/:LayoutId?/:TestPageId?',
    channel: null,
    varnish: true
  }
});
